import { CircularProgress } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import React, { lazy, Suspense } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import GlobalState from "./context/GlobalState";
import NavBar from "./components/Navbar";
import Footer from "./components/Footer";
import IndexPage from "./pages/index/Index";
import { PagePath, AdminAccess } from "./types";
import { AuthRoute } from "./components/AuthRoute";

const NotFoundPage = lazy(() => import("./pages/notFound/Index"));
const AboutPage = lazy(() => import("./pages/about/Index"));
const CheckPage = lazy(() => import("./pages/check/Index"));
const ComplainPage = lazy(() => import("./pages/complain/Index"));
const LankePage = lazy(() => import("./pages/lanke/Index"));
const RepairPage = lazy(() => import("./pages/repair/Index"));
const SuggestPage = lazy(() => import("./pages/suggest/Index"));
const WechatPage = lazy(() => import("./pages/wechat/Index"));
const AdminPage = lazy(() => import("./pages/admin/Index"));

function App(): JSX.Element {
  const darkThemeSys = useMediaQuery("(prefers-color-scheme: dark)", {
    noSsr: true
  });
  const theme = createMuiTheme({
    palette: {
      primary: {
        main: "#0D56A6"
      },
      secondary: {
        main: "#00acc1"
      },
      type: darkThemeSys ? "dark" : "light"
    }
  });

  return (
    <MuiThemeProvider theme={theme}>
      <GlobalState>
        <BrowserRouter>
          <CssBaseline />

          {/* place holder for sticky footer */}
          <div style={{ minHeight: "calc(100vh - 176px)" }}>
            <NavBar />
            <Suspense fallback={<CircularProgress />}>
              <Switch>
                <Route path={PagePath.Index} exact component={IndexPage} />
                <Route path={PagePath.About} component={AboutPage} />
                <Route path={PagePath.Check} component={CheckPage} />
                <Route path={PagePath.Complain} component={ComplainPage} />
                <Route path={PagePath.Lanke} component={LankePage} />
                <Route path={PagePath.Suggest} component={SuggestPage} />
                <Route path={PagePath.Wechat} component={WechatPage} />
                <AuthRoute // [需认证]报修页面
                  pageAccessCode={AdminAccess.Dashboard}
                  path={PagePath.Repair}
                >
                  <RepairPage />
                </AuthRoute>
                <Route path={PagePath.Admin} component={AdminPage} />
                {/* No Match */}
                <Route component={NotFoundPage} />
              </Switch>
            </Suspense>
          </div>

          <Footer />
        </BrowserRouter>
      </GlobalState>
    </MuiThemeProvider>
  );
}

export default App;
